/*
 * =================================================================
 * PDP AFO MODULE SCRIPT (UPGRADED FOR MULTIPLE SLIDERS)
 * =================================================================
 * This script is wrapped in an IIFE to prevent conflicts.
 * The slider function has been upgraded to find and initialize
 * ALL sliders on a page, not just the first one.
 */

(function() { // Start of IIFE "insurance box"

    document.addEventListener('DOMContentLoaded', function() {

        // --- 模块一: "About this item" 展开/折叠功能 (No changes here) ---
        const aboutModule = document.getElementById('pdp-afo-about-module');
        const aboutToggle = document.getElementById('pdp-afo-about-toggle');
        if (aboutModule && aboutToggle) {
            aboutToggle.addEventListener('click', () => {
                const isExpanded = aboutModule.classList.toggle('expanded');
                const toggleText = aboutToggle.querySelector('.toggle-text');
                if (toggleText) {
                    toggleText.textContent = isExpanded ? 'See less' : 'See more';
                }
            });
        }

        // --- 模块二: 通用滑块功能 (UPGRADED) ---
        // This function now initializes a SINGLE slider element that is passed to it.
        function initializeSlider(sliderElement) {
            const container = sliderElement; // The slider wrapper is passed directly
            if (!container) return;

            const track = container.querySelector('.pdp-afo-slider-track');
            if (!track) return;

            const slides = Array.from(track.children);
            const nextButton = container.querySelector('.pdp-afo-arrow.next');
            const prevButton = container.querySelector('.pdp-afo-arrow.prev');

            if (slides.length <= 1) {
                if (nextButton) nextButton.style.display = 'none';
                if (prevButton) prevButton.style.display = 'none';
                return;
            }

            let currentIndex = 0;
            const moveToSlide = (index) => {
                currentIndex = (index + slides.length) % slides.length;
                track.style.transform = `translateX(-${currentIndex * 100}%)`;
            };

            if (nextButton) nextButton.addEventListener('click', () => moveToSlide(currentIndex + 1));
            if (prevButton) prevButton.addEventListener('click', () => moveToSlide(currentIndex - 1));
        }

        // --- 模块三: FAQ (常见问题) 折叠功能 (No changes here) ---
        const faqItems = document.querySelectorAll('.pdp-afo-faq-item');
        faqItems.forEach(item => {
            const question = item.querySelector('.pdp-afo-faq-question');
            const answer = item.querySelector('.pdp-afo-faq-answer');
            if (question && answer) {
                question.addEventListener('click', () => {
                    const isActive = item.classList.toggle('active');
                    answer.style.maxHeight = isActive ? answer.scrollHeight + 'px' : '0';
                });
            }
        });

        // --- 模块四: 动态视频库功能 (No changes here) ---
        const galleryContainer = document.querySelector('.pdp-afo-video-gallery');
        if (galleryContainer) {
            const videosJson = galleryContainer.dataset.videos;
            let videos = [];
            if (videosJson) {
                try {
                    videos = JSON.parse(videosJson);
                } catch (e) {
                    console.error("无法解析视频数据(JSON格式错误)，请检查产品描述中的 data-videos 属性。", e);
                    return;
                }
            }
            if (videos.length > 0) {
                const titleEl = document.getElementById('pdp-afo-main-video-title');
                const embedEl = document.getElementById('pdp-afo-main-video-embed');
                const playlistContainer = document.getElementById('pdp-afo-playlist-container');
                function loadVideo(videoData) {
                    if (titleEl) titleEl.textContent = videoData.title;
                    if (embedEl) embedEl.innerHTML = `<iframe src="https://www.youtube.com/embed/${videoData.id}?autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                    document.querySelectorAll('.pdp-afo-playlist-item').forEach(item => {
                        item.classList.remove('playing');
                        if (item.dataset.videoId === videoData.id) {
                            item.classList.add('playing');
                        }
                    });
                }
                if (playlistContainer) {
                    playlistContainer.innerHTML = '';
                    videos.forEach(video => {
                        const item = document.createElement('div');
                        item.className = 'pdp-afo-playlist-item';
                        item.dataset.videoId = video.id;
                        item.innerHTML = `<img src="https://img.youtube.com/vi/${video.id}/mqdefault.jpg" alt="${video.title}"><div class="pdp-afo-playlist-title">${video.title}</div>`;
                        item.addEventListener('click', () => loadVideo(video));
                        playlistContainer.appendChild(item);
                    });
                }
                const firstVideo = videos[0];
                const firstPlaylistItem = playlistContainer.querySelector('.pdp-afo-playlist-item');
                if (titleEl) titleEl.textContent = firstVideo.title;
                if (embedEl) embedEl.innerHTML = `<iframe src="https://www.youtube.com/embed/${firstVideo.id}?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                if (firstPlaylistItem) firstPlaylistItem.classList.add('playing');
            }
        }

        // --- 初始化所有滑块 (UPGRADED) ---
        // Find ALL feature sliders on the page and initialize each one.
        const allFeatureSliders = document.querySelectorAll('.pdp-afo-feature-slider');
        allFeatureSliders.forEach(slider => initializeSlider(slider));

        // Find ALL review sliders on the page and initialize each one.
        const allReviewSliders = document.querySelectorAll('.pdp-afo-review-slider');
        allReviewSliders.forEach(slider => initializeSlider(slider));

    }); // End of DOMContentLoaded

})(); // End of IIFE "insurance box"